import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  FileDoneOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const TermosItens = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // DADOS
  const [dados, setDados] = useState([]);

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  // DADOS TERMO
  const [termo, setTermo] = useState({});
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (id) {
      carregarTermo(id);
      listarTermosItens(id);
    }
  }, [id]);

  // CARREGAR TERMO
  const carregarTermo = async (id_termo) => {
    if (!id_termo) return;
    setLoading(true);
    const api = await http("get", `v1/termos/carregar/${id_termo}`, []);

    if (api.statusCode === 200) {
      setTermo(api.response.data);
    } else {
      navigate("/termos/cadastro");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR TERMOS ITENS
  const listarTermosItens = async (id_termo) => {
    setLoading(true);
    const api = await http("get", `v1/termos_itens/listar/${id_termo}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR TERMO ITEM
  const cadastrarTermoItem = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/termos_itens/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarTermosItens(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR TERMO ITEM
  const carregarTermoItem = async (id_item) => {
    if (!id_item) return;
    setLoading(true);
    const api = await http("get", `v1/termos_itens/carregar/${id_item}`, []);
    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: api.response.data.descricao,
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR TERMO ITEM
  const alterarTermoItem = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/termos_itens/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarTermosItens(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR TERMO ITEM
  const deletarTermoItem = async (id_item) => {
    setLoading(true);
    const api = await http("post", `v1/termos_itens/deletar`, { id: id_item });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarTermosItens(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarTermoItem(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarTermoItem(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_cad_termos_ciencia = id;

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarTermoItem(formulario);
    } else {
      cadastrarTermoItem(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter((val) => val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()));

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Item
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Informe a descrição!" }]}>
                <Input.TextArea
                  size="large"
                  disabled={loading}
                  placeholder="Informe a descrição"
                  rows={6}
                  autoSize={{ minRows: 5, maxRows: 7 }}
                />
              </Form.Item>
            </Col>

            <Col style={{ marginTop: "10px" }} className="gutter-row" span={24}>
              <Space direction="vertical" size={2}>
                <Text type="secondary">Menções:</Text>
                <Text type="secondary">
                  <ul>
                    <li>
                      Digite <Text strong>{"{{nome}}"}</Text> para referenciar o nome do colaborador.
                    </li>
                    <li>
                      Digite <Text strong>{"{{filial}}"}</Text> para referenciar a filial do colaborador.
                    </li>
                    <li>
                      Digite <Text strong>{"{{cpf}}"}</Text> para referenciar o CPF do colaborador.
                    </li>
                    <li>
                      Digite <Text strong>{"{{matricula}}"}</Text> para referenciar a matrícula do colaborador.
                    </li>
                  </ul>
                </Text>
              </Space>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Configurações" onClickBack={() => navigate("/termos/cadastro")} />
            <HeaderTitle
              title="Termo Itens"
              subtitle={
                <Text italic>
                  <FileDoneOutlined /> {termo?.descricao ?? ""}
                </Text>
              }
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                </Space>
              </Space>
              <Divider />
              <Table rowKey="id" scroll={{ x: 700 }} columns={columns} dataSource={dadosFilter} size="small" />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
